export default {
  catalog_id_placeholder: '№ ',
  country: 'Ülke',
  region: 'Bölge',
  city: 'Şehir',
  district: 'Semt',
  category: 'Kategori',
  type: 'Tür',
  subtype: 'Alt tür',
  purpose: 'İşlem türü',
  any: 'Herhangi',
  apply: 'Uygula',
  reset: 'Sıfırla',
  show: 'Filtreyi göster',
  hide: 'Filtreyi gizle',

  purpose_options: {
    sale: 'Satış',
    rental: 'Uzun dönem kiralama',
    daily_rent: 'Kısa dönem kiralama',
    investment: 'Yatırım',
    holiday: 'Tatil / Dinlenme',
    commercial_use: 'Ticari kullanım',
    residence: 'Konut kullanımı'
  }

}
